import { defineMessage } from 'react-intl'

import { OPTIONS_TYPE, PreferenceMetadataConfig } from './types'
import { CountryNameToISOCode } from '../../intl/constants'
import {
  MEMBER_PREFERENCE_IDS,
  MEMBER_PREFERENCE_NAMES,
  S4C_PROGRAM_OPTION_FLOW,
} from '../../memberPreferences/constants'
import { MEMBER_PREFERENCE_LABELS } from '../../searchForCare/messages'

const optionsDefault = [
  {
    text: MEMBER_PREFERENCE_LABELS.experienceWorkingWithVeterans,
    id: MEMBER_PREFERENCE_IDS.EXPERIENCE_WORKING_WITH_VETERANS,
    selectedTextLabel: MEMBER_PREFERENCE_LABELS.isExperiencedWithVeterans,
  },
]

const optionsMilitary = [
  {
    text: MEMBER_PREFERENCE_LABELS.experienceWorkingWithMilitaryClients,
    id: MEMBER_PREFERENCE_IDS.EXPERIENCE_WORKING_WITH_VETERANS,
    selectedTextLabel: MEMBER_PREFERENCE_LABELS.isExperiencedWithMilitaryClients,
  },
]

const veteransPreference: PreferenceMetadataConfig = {
  name: MEMBER_PREFERENCE_NAMES.IS_EXPERIENCED_WITH_VETERANS,
  title: MEMBER_PREFERENCE_LABELS.isExperiencedWithVeterans,
  optionType: OPTIONS_TYPE.CHECKBOX,
  icon: 'MemberPreferencesVeteransIllustrationIcon',
  promptText: defineMessage({
    defaultMessage: 'I prefer a provider who has:',
    description: 'Text prompting the user to select options they associate with',
  }),
  countryConfig: {
    [CountryNameToISOCode.Israel]: {
      title: MEMBER_PREFERENCE_LABELS.isExperiencedWithMilitaryClients,
      programOptionFlows: [S4C_PROGRAM_OPTION_FLOW.THERAPY],
      options: optionsMilitary,
    },
    [CountryNameToISOCode.UnitedStatesOfAmerica]: {
      programOptionFlows: [
        S4C_PROGRAM_OPTION_FLOW.COACHING,
        S4C_PROGRAM_OPTION_FLOW.COACHING_WITH_LMS,
        S4C_PROGRAM_OPTION_FLOW.THERAPY,
      ],
      options: optionsDefault,
    },
  },
}

export default veteransPreference
